import React, {useEffect, useState} from "react";
import {
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
  LinearProgress,
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import useAxios from 'axios-hooks';
import {Link, Redirect} from 'react-router-dom';

import TextField from 'Components/Universal/TextField';
import BaseAuth from './BaseAuth';
import {useStyles} from './styles';
import {signinRequest} from "../../../Api";
import {setAuthToken} from "../../../Helpers";


const SignUpPage = () => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [errorMsg, setErrorMsg] = useState('');
  const [{error, loading, response}, signInAction] = useAxios(signinRequest(), { manual: true });

  const fieldChange = e => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  useEffect(() => {
    if (error) {
      console.log(error, response);
      setErrorMsg(`Unhandled error from our server: ${error.message}`);
    } else if (response && response.data) {
      if (response.data.error) {
        setErrorMsg(response.data.message);
      } else {
        setAuthToken(response.data.token);
        window.location.href = '/';
      }
    }
  }, [response, error]);

  const handleSubmit = e => {
    e.preventDefault();
    setErrorMsg('');
    signInAction({
      data: {
        advertiser_email: formData.email,
        advertiser_password: formData.password,
      },
    });
  };

  return (
    <BaseAuth title="Sign in to your Focusloop account">
      <div
        style={{
          padding: 32,
          borderRadius: 4,
          backgroundColor: 'white',
          marginBottom: '32px'
        }}
      >
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            type='email'
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={fieldChange}
            value={formData.email}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={fieldChange}
            value={formData.password}
          />
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          {loading && <LinearProgress />}
          {errorMsg && errorMsg.length > 0 && (
            <Alert severity="error">{errorMsg}</Alert>
          )}
          <Button
            type={loading ? 'button' : 'submit'}
            fullWidth
            variant="contained"
            color="primary"
            className={`${classes.submit} ${classes.mainButton}`}
            disabled={loading}
            style={{ borderWidth: 3 }}
          >
            Sign In
          </Button>
        </form>
      </div>
      <Grid container>
        <Grid item xs>
          <Link to="/auth/forgot" variant="body2" style={{ color: 'white' }}>
            Forgot password?
          </Link>
        </Grid>
        <Grid item>
          <Link to='/auth/signup' variant="body2" style={{ color: 'white' }}>
            {"Don't have an account? Sign Up"}
          </Link>
        </Grid>
      </Grid>
    </BaseAuth>
  );
};

export default SignUpPage;
